import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import ReportsSection from "../components/RegisterAsFarmOrganization/ReportDropdown2"
import LanguageSelector from '../components/RegisterAsFarmOrganization/LangugageSelector';
import PersonalInfoForm from '../components/RegisterAsFarmOrganization/PersonalInfoForm';
import OrganizationForm from '../components/RegisterAsFarmOrganization/OrganizationForm';
import IndustrySection from '../components/RegisterAsFarmOrganization/IndustrySection';
import OfficialNews from '../components/RegisterAsFarm/OfficialNews';
import ProfingSkils from "../components/RegisterAsFarmOrganization/ProfingSkils";
import MembershipSection from "../components/RegisterAsFarmOrganization/MembershipSection";
import { onAuthStateChanged } from "firebase/auth";
import SectionD from '../components/RegisterAsFarmOrganization/SectionD';
import SectionDnew from '../components/RegisterAsFarmOrganization/SectionDnew';
import BackgroundInfoSection from '../components/RegisterAsFarmOrganization/BackgroundInfoSection';
import LocationPicker from "./LocationPicker";
import Project from '../components/RegisterAsFarmOrganization/Project';
import { motion, AnimatePresence } from "framer-motion";
import Dropdown1 from '../components/RegisterAsFarmOrganization/Dropdown';
import GroupExperience from '../components/RegisterAsFarmOrganization/GroupExperience';
import Modal from 'react-modal';
import SaveButtonWithModal from '../components/SaveButtonWithModel';
import { getFirestore, setDoc, doc } from "firebase/firestore";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { generateRegistrationNumber } from "../utils/generateRegNumber";
import { uploadToCloudinary } from "../utils/CloudinaryUpload";
import { sendRegistrationEmail } from "../utils/sendRegistrationsEmail";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from '../firebase'; // Make sure `firebaseConfig` is exported from your firebase.js

// Init Firebase singletons
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const dropdownItems = {
  FACILITATOR: [
    "Individual", "Entrepreneur", "Learners", "Moderator", "Facilitator", "Assessor", "Evaluator", "Training provider", "Cooperative", "Community", "EIA"
  ],
  PURPOSE: [
    "Funding", "Training", "Resourcing", "Market", "M&E", "Assessment", "Evaluations", "Impact"

  ],

};

const initialReportSelections = {
  COUNTRY: "SOUTH AFRICA",
  REGION: "Eastern Cape",
  MUNICIPALITY: "Johannesburg",
  TYPE: "Learners",
  "VALUE CHAIN": "Maize",
  PROJECT: "ABATTOIR",
};

const Dropdown = ({ label, items, type, isProjectDropdown, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);
  const [selectedCircles, setSelectedCircles] = useState({});

  const toggleCircle = (item) => {
    setSelectedCircles((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const handleSelect = (item) => {
    setSelected(item);
    setIsOpen(false);
    if (typeof onChange === "function") {
      onChange(type, item);
      // Show in console exactly when user selects:
      console.log(`Selected ${type}:`, item);
    }
  };

  return (
    <div className="flex flex-col w-full relative">
      {/* Button */}
      <div className="flex relative z-20 w-fit">
        <button
          onClick={() => {
            if (isProjectDropdown && selected?.toLowerCase() === "funding") {
              window.location.href = "/funding";
            } else {
              setIsOpen((prev) => !prev);
            }
          }}
          className={`xl:w-[168px] lg:w-[140px] md:w-[55px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
        >
          <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px]">
            {selected}
          </span>
        </button>
        <div
          className="w-[15px] h-[15px] md:h-[53px] md:w-[37px] bg-[#F38323] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="w-2 h-[10px] md:w-6 md:h-[24px]"
          />
        </div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 left-0 z-50 md:w-[220px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2"
          >
            <li className="flex items-center justify-between px-2 py-1 mb-2">
              <span className="text-[6px] md:text-[20px] font-semibold">
                Registration - Type of users
              </span>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                alt="icon"
                className="md:w-[30px] md:h-[30px] h-[7px] w-[7px]"
              />
            </li>
            {items.map((item, index) => (
              <li
                key={index}
                className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${selected === item ? 'bg-[#E7EBEB]' : ''}`}
                onClick={() => handleSelect(item)}
              >
                <span className="text-black text-[4px] md:text-[18px]">
                  {item}
                </span>
                <div
                  onClick={e => {
                    e.stopPropagation();
                    toggleCircle(item);
                  }}
                  className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${selected === item ? "bg-[#03897B]" : "bg-gray-200"}`}
                ></div>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
      <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
        {isProjectDropdown
          ? "Select PURPOSE"
          : `Select ${type === "FACILITATOR" ? "user type" : label}`}
      </p>
    </div>
  );
};


const languages = [
  'Owned', 'Commonage', 'Community Owned', 'Municipal Land', 'House with a plot',
  'Urban lot', 'Community Food garden allocation', 'No Land Yet',
];
const languages1 = [
  'Leased', 'Community Leased', 'Road side vacant land', 'Village / Local/ Tribunal Authority allocation'

];

const RegisterOrganization = () => {
  const [selected, setSelected] = useState(null); // <-- initially nothing selected
  const [selected1, setSelected1] = useState(null); // <-- initially nothing selected
  const [selectedBox, setSelectedBox] = useState(null);
  const keys = Object.keys(dropdownItems);
  const handleBoxClick = (index) => {
    setSelectedBox(index);
  };

  const [certificatesUrls, setCertificatesUrls] = useState([]);
  const [idDocumentUrl, setIdDocumentUrl] = useState("");
  const [dropdownSelections, setDropdownSelections] = useState({
    user_type: dropdownItems.FACILITATOR[0],
    user_purpose: dropdownItems.PURPOSE[0]
  });
  const [landType1, setLandType1] = useState("");
  const [landType2, setLandType2] = useState("");
  const [erfNumber, setErfNumber] = useState("");
  // ... other state
  const [selectedS, setSelectedS] = useState("Agri"); // initial SETA
  const [selectedQ, setSelectedQ] = useState("Business Administration"); // initial Qualification

  const handleDropdownSave = (data) => {
    // Log all values from the dropdowns in registration page
    console.log(' SETA and Qualification:', data);
    // data = { SETA: "Bank", QUALIFICATIONS: "IT Technical Support" }
  };
  const handleBackgroundSave = (data) => {
    // Log all background info
    console.log('Background Info:', data);
  };
  const handleDropdownChange = (type, value) => {
    // Map dropdown type to your desired object keys
    const keyMap = {
      FACILITATOR: 'user_type',
      PURPOSE: 'user_purpose'
    };

    const mappedKey = keyMap[type];

    setDropdownSelections(prev => ({
      ...prev,
      [mappedKey]: value
    }));

    // Log only the mapped keys and latest values
    console.log({
      user_type: type === "FACILITATOR" ? value : dropdownSelections.user_type,
      user_purpose: type === "PURPOSE" ? value : dropdownSelections.user_purpose
    });
  };
  const [selectedChallenges, setSelectedChallenges] = useState([]);
  const [vision, setVision] = useState("");

  const handleIndustrySave = (data) => {
    console.log('Industry Activity Survey:', data);
    // {
    //   cooperativeName: ...,
    //   section: ...,
    //   vision: ...,
    //   selectedChallenges: [...]
    // }
  };
  const [selectedExperience, setSelectedExperience] = useState([]);
  const [focusSelected, setFocusSelected] = useState([]);
  const [selectedType, setSelectedType] = useState("");

  const handleFocusSave = (data) => {
    console.log("Areas of Focus:", data);
    // {
    //   cooperativeName: ...,
    //   typeOfFocus: ...,
    //   selectedAreas: [...],
    //   selectedDisabilityType: ...
    // }
  };
  const [selectedOption, setSelectedOption] = useState("Maize");
  const [selectedCategories, setSelectedCategories] = useState([]);

  const handleSectionDSave = (data) => {
    // data = { typeOfOrganization: ..., categories: [...] }
    console.log("Section D Industry Interest:", data);
  };

  const handleGroupExperienceSave = (data) => {
    console.log('Group Experience:', data);
    // Example:
    // {
    //   cooperativeName: 'YourCooperativeName',
    //   typeOfGroupExperience: 'Personal, Group or Cooperative Experience',
    //   selectedExperience: [...]
    // }
  };

  // ProfingSkils state
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedMembership, setSelectedMembership] = useState(""); // e.g. "AFASA" or "Others"
  const handleMembershipSave = (value) => {
    // Example: add more keys if needed
    console.log("Membership/Affiliation Selected:", value);
  };
  const handleProfingSkillsSave = (skills) => {
    // Example: log with cooperative name and type if you have them
    const data = {
      PersonalSkillsTrainingandQualifications: 'PersonalSkillsTrainingandQualifications', // replace/fetch as needed
      typeOfProfingSkill: 'Personal Skills Training and Qualifications',
      selectedSkills: skills,
    };
    console.log('Profing Skills:', data);
  };
  const [selectedLocation, setSelectedLocation] = useState(null);

  // Add your main save handler (use the same function as your Register button)
  const [savedLocation, setSavedLocation] = useState(null);

  // Call this when Register button is clicked
  const handleRegisterSave = () => {
    const cooperative = {
      // ...other registration fields,
      location: savedLocation
    };
    console.log("location:", cooperative);
    // ...show modal, etc.
  };

  const [location, setLocation] = useState(null);

  // This gets called when "Save Location" is clicked inside LocationPicker
  const [locationCountry, setLocationCountry] = useState("");

  const handleSaveLocation = (country) => {
    setLocationCountry(country);
    console.log("User selected country:", country);
  };


  const [showUnits, setShowUnits] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState("Hectare");
  const [landSize, setLandSize] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copyMessage, setCopyMessage] = useState('');
  const handleSaveClick = () => {
    setIsModalOpen(true);
  };


  const handleCopy = () => {
    navigator.clipboard.writeText('ZA25-582-9511');
    setCopyMessage('Copied!'); // Set the "Copied!" message

    // Hide the message after 2 seconds
    setTimeout(() => {
      setCopyMessage('');
    }, 2000);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const units = ["Hectare", "Acre", "Square Meter"];
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      padding: '20px',
      borderRadius: '10px',
      backgroundColor: 'white',
      textAlign: 'center',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  };
  const handleUnitSelect = (unit) => {
    setSelectedUnit(unit);
    setShowUnits(false);
  };
  const [agreed, setAgreed] = useState(false);
  // Report dropdown state
  const [reportSelections, setReportSelections] = useState(initialReportSelections);

  // Handler for report dropdowns
  const handleReportDropdownChange = (type, value) => {
    setReportSelections(prev => {
      const updated = { ...prev, [type]: value };
      // Log with readable keys (convert keys if you want)
      console.log({
        country: updated.COUNTRY,
        region: updated.REGION,
        municipality: updated.MUNICIPALITY,
        type: updated.TYPE,
        value_chain: updated["VALUE CHAIN"],
        project: updated.PROJECT
      });
      return updated;
    });
  };
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const handleLanguageChange = (lang) => {
    setSelectedLanguage(lang);
    console.log("Selected language:", lang);
  };
  const [formData, setFormData] = useState({
    firstName: "",
    surname: "",
    dateOfBirth: "",
    typeOfId: "",
    idNumber: "",
    mobile: "",
    email: "",
    password: "",
    whatsapp: "",
    physicalAddress: "",
    postalCode: "",
  });
  const [race, setRace] = useState("");
  const [gender, setGender] = useState("");
  const [disability, setDisability] = useState("");

  // Log all values here when Save is clicked in PersonalInfoForm
  const handlePersonalInfoSave = (data) => {
    console.log('Personal Info Form Data:', data);
  };

  const [orgFormData, setOrgFormData] = useState({
    cooperativeName: "",
    registrationNumber: "",
    members: "",
    mobileNumber: "",
    physicalAddress: "",
    chairFirstName: "",
    chairSurname: "",
    secretaryFirstName: "",
    secretarySurname: "",
    email: "",
    password: "",
  });
  const [orgType, setOrgType] = useState("COOPERATIVE 1");

  const handleOrgSave = (data) => {
    // This logs all org fields to the console
    console.log('Organization Form Data:', data);
  };

  const [loading, setLoading] = useState(false);
  const [progressMsg, setProgressMsg] = useState("");
  const [registrationError, setRegistrationError] = useState(null);
  const [registrationNumber, setRegistrationNumber] = useState("");

  const onHandleSave = async () => {
    setLoading(true);
    setProgressMsg("Saving...");
    setRegistrationError(null);

    const email = orgFormData.email;
    const password = orgFormData.password;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setRegistrationError("Please provide a valid organization email address.");
      setLoading(false);
      return;
    }
    if (!password || password.length < 6) {
      setRegistrationError("Please provide a password with at least 6 characters.");
      setLoading(false);
      return;
    }

    try {
      // 1. Create Firebase Auth user
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const uid = userCredential.user.uid;

      // 2. Generate Registration Number
      const regNumber = generateRegistrationNumber();

      // 3. Build registration payload
      const registrationPayload = {
        registrationType: "organization",
        userType: dropdownSelections.user_type,
        userPurpose: dropdownSelections.user_purpose,
        reportSelections,
        language: selectedLanguage,
        organizationInfo: {
          ...orgFormData,
          orgType,
          certificates: certificatesUrls,
          idDocument: idDocumentUrl,
        },
        registrationNumber: regNumber,
        createdAt: new Date().toISOString(),
        uid,
      };

      // 4. Save to Firestore
      await setDoc(doc(db, "registrations", uid), registrationPayload);

      // 5. Send email
      await sendRegistrationEmail({
        user_name: orgFormData.cooperativeName,
        registration_number: regNumber,
        user_email: orgFormData.email,
        user_type: "organization",
        name: orgFormData.cooperativeName,
        email: orgFormData.email,
      });

      // 6. Finish
      setLoading(false);
      setRegistrationNumber(regNumber);
      setIsModalOpen(true);
    } catch (e) {
      setLoading(false);
      setRegistrationError(e.message);
      console.error("Registration error:", e);
    }
  };
  const navigate = useNavigate();
  const [selected3, setSelected3] = useState('Organization'); // This sets second bar green by default

  return (
    <div>
      <div className='md:px-28 px-4'>
        <div className=" w-full  mx-auto md:pt-1 pt-2">
          <h2 className="text-left font-bold text-[14px] text-[#03897B] md:text-[36px]">
            REGISTRATION
          </h2>
          {/* Labels directly above the bar */}
          <div>
            <div className="relative w-full mx-auto h-[40px] md:mb-4 md:mt-3 mb-0">
              <a href='/RegisterAsFarmMain'>
                <span
                  className={`absolute top-0 left-[25%] sm:left-[25%] -translate-x-1/2 text-[8px] sm:text-[36px] font-bold cursor-pointer transition-colors duration-200 ${selected3 === 'Individual' ? 'text-black' : 'text-black'
                    }`}
                  onClick={() => setSelected3('Individual')}
                >
                  Individual
                </span>
              </a>

              <span
                className={`absolute top-0 left-[75%] sm:left-[75%] -translate-x-1/2 text-[8px] sm:text-[36px] font-bold cursor-pointer transition-colors duration-200 ${selected3 === 'Organization' ? 'text-black' : 'text-black'
                  }`}
                onClick={() => setSelected3('Organization')}
              >
                Organization
              </span>
            </div>

            {/* Toggle Bar */}
            <div className="w-full md:h-[10px] h-[4px] bg-[#D9D9D9] flex rounded-[10px] overflow-hidden md:mt-0 mb-2 -mt-5 md:mb-6 mx-auto">
              {/* Individual Side */}

        <div
                className="w-1/2 h-full cursor-pointer relative"
                onClick={() => setSelected3('Individual')}
              >
                <div
                  className={`absolute inset-0 transition-all duration-300 ${selected3 === 'Individual' ? 'bg-[#D9D9D9]' : 'bg-[#D9D9D9]'
                    } rounded-[10px]`}
                ></div>
              </div>

              {/* Organization Side */}
 <a href='/RegisterAsFarmOrganization'
                className="w-1/2 h-full cursor-pointer relative"
              >
                <div
                  className={`absolute inset-0 transition-all duration-300 ${selected3 === 'Organization' ? 'bg-[#03897B]' : 'bg-[#03897B]'
                    } rounded-[10px]`}
                ></div>
              </a>


            </div>
          </div>

          <div className="flex justify-between items-center w-full ">
            {/* LEFT SIDE - HEADING */}
            <div>

              <div className="flex-1 md:mt-2">
                <div>
                  <div className="flex md:flex-row items-start md:gap-4 gap-1 ">

                    <div className="md:w-[310px] w-[80px] md:max-w-[310px]">
                      <button className="w-full h-[20px] md:h-[60px] text-left rounded-[5px] px-2 md:px-4 bg-[#E7EBEB] border-b-[4px] border-[#919291] text-[5px] md:text-[20px] font-bold">
                        Entrepreneurs challenges
                      </button>
                      <p className='text-[4px] md:text-[16px] leading-tight font-normal mt-1'>
                        Click to read entrepreneurs <br /> challenges
                      </p>
                    </div>

                    <div className="md:w-full w-[80px] md:max-w-[290px]">
                      <button className="w-full h-[20px] md:h-[60px] text-left px-1 md:px-4 rounded-[5px] bg-[#E7EBEB] border-b-[4px] border-[#919291] text-[5px] md:text-[20px] font-bold">
                        Benefits of registration
                      </button>
                      <p className='text-[4px] md:text-[16px] font-normal mt-1'>
                        Click to read benefits of registration
                        <br />
                        <span className="text-transparent">sss</span>
                      </p>
                    </div>

                  </div>
                </div>
              </div>
            </div>


            {/* RIGHT SIDE - DROPDOWNS */}
            <div className="flex gap-4 flex-wrap justify-end md:-mt-5 ">
              {keys.map((type, index) => {
                const customLabels = {
                  Crop: "Crop Report",
                  Livestock: "Livestock Report",
                  Type: "Type of Report",
                };

                const displayLabel = customLabels[type] || type;
                const isProjectDropdown = index === keys.length - 1;

                return (
                  <div key={type} className="w-auto">
                    <Dropdown
                      label={displayLabel}
                      items={dropdownItems[type]}
                      type={type}
                      isProjectDropdown={isProjectDropdown}
                      onChange={handleDropdownChange}
                    />
                  </div>
                );
              })}
            </div>

          </div>
          <ReportsSection values={reportSelections} onChange={handleReportDropdownChange} />
          <LanguageSelector onChange={handleLanguageChange} />
          {/* 
          <OfficialNews /> */}
        </div>

        <OrganizationForm
        formData={orgFormData}
        onFormDataChange={setOrgFormData}
        selectedOption={orgType}
        onOptionChange={setOrgType}
        onCertificatesUrlChange={setCertificatesUrls}
        onIdUrlChange={setIdDocumentUrl}
      />
        <BackgroundInfoSection
          languages={languages}
          languages1={languages1}
          selected={landType1}
          setSelected={setLandType1}
          selected1={landType2}
          setSelected1={setLandType2}
          erfNumber={erfNumber}
          setErfNumber={setErfNumber}
          onSave={handleBackgroundSave}
        />
        <div>

        </div>

        <div >

          <Dropdown1
            selectedS={selectedS}
            setSelectedS={setSelectedS}
            selectedQ={selectedQ}
            setSelectedQ={setSelectedQ}
            onSave={handleDropdownSave}
          />

          <MembershipSection
            selectedMembership={selectedMembership}
            setSelectedMembership={setSelectedMembership}
            onSave={handleMembershipSave}
          />
          <GroupExperience
            selectedExperience={selectedExperience}
            setSelectedExperience={setSelectedExperience}
            onSave={handleGroupExperienceSave}
          />
          <SectionDnew
            selected={focusSelected}
            setSelected={setFocusSelected}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            onSave={handleFocusSave}
          />
          <SectionD
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
            onSave={handleSectionDSave}
          />
          <IndustrySection
            selected={selectedChallenges}
            setSelected={setSelectedChallenges}
            vision={vision}
            setVision={setVision}
            onSave={handleIndustrySave}
          />

          {/* Save button */}

          <div>
            {/* Save button */}


            <SaveButtonWithModal />
          </div>
          {/* Location Section */}
          <div className="md:-mt-3 flex items-center space-x-3">
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744662306/image_1570_pnbwi8.png" alt=".." className="md:w-[37px] w-[17px] h-[17px] md:h-[37px]" />
            <h1 className="md:text-[36px] text-[10px] font-bold">Set Location</h1>
          </div>
          <div className="h-auto w-full rounded-md mt-3 md:pb-4 pb-2">
            <LocationPicker onSaveLocation={handleSaveLocation} />
            <div >
              {/* Checkbox Box */}
              <div className="flex flex-col justify-end  ">


                {/* Buttons */}
                <div className="flex md:gap-4 gap-1  justify-end mt-2">
                  {/* Edit Button */}
                  <div>
                    <button className="flex items-center justify-between md:w-[230px] w-[100px] md:h-[61px] h-[20px] bg-[#03897B] text-white md:text-[14px] text-[6px] font-bold rounded-[10px] md:px-8 px-4 ">
                      <span>EDIT</span>
                      <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
                        alt="Edit Icon"
                        className="md:w-[35px] h-2  md:h-[38px] w-2 "
                      />
                    </button>
                    <p className='md:text-[14px] text-[6px] md:mt-4  mt-1 font-normal md:px-1 '>
                      Edit registration form
                    </p>
                  </div>


                  {/* Save Button */}
                  <div>
                    <button className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4" onClick={handleSaveClick}>
                      <span>SAVE</span>
                      <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690487/Arhive_load_duotone_line_1_hbsukd.png"
                        alt="Save Icon"
                        className="md:w-[35px] h-2  md:h-[38px] w-2 "
                      />
                    </button>
                    <p className='md:text-[14px]  text-[6px] md:mt-4 mt-1 font-normal md:px-1 '>
                      Save registration
                    </p>
                  </div>
                </div>
              </div>
              <div className='flex gap-4 items-center mt-5'>
      <div
        className="md:w-16 md:h-[63px] w-6 h-[30px] rounded-[5px] bg-[#D9D9D9] flex items-center justify-center cursor-pointer transition"
        onClick={() => setAgreed((prev) => !prev)}
        tabIndex={0}
        aria-pressed={agreed}
        aria-label="Confirm terms and conditions"
      >
        {/* Black or Green Check Round Fill SVG */}
        {agreed ? (
          // GREEN CHECK ROUND FILL
          <svg
            width="54"
            height="54"
            viewBox="0 0 54 54"
            fill="none"
            className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="27" cy="27" r="27" fill="#18C964"/>
            <path d="M39 21L24.75 35L15 25.4545" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        ) : (
          // BLACK CHECK ROUND FILL
          <svg
            width="54"
            height="54"
            viewBox="0 0 54 54"
            fill="none"
            className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="27" cy="27" r="27" fill="#222"/>
            <path d="M39 21L24.75 35L15 25.4545" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
      </div>
      <p className="md:text-[20px] text-[6px]">
        By ticking I confirm that I agree with the{" "}
        <a className="underline hover:text-teal-600" href='/TermsAndCondition'>Terms and conditions</a>, <span className='underline'>Data </span>and{" "}
        <a className="underline hover:text-teal-600" href='/PrivacyPolicy'>Privacy policy</a>.
      </p>
    </div>
              {/* Text */}

            </div>
          </div>


          {/* Register Button */}
          <button
            onClick={onHandleSave}
            disabled={loading}
            className="w-full bg-[#03897B] flex justify-center md:text-[28px] text-[8px]  font-bold  items-center md:mt-0  border-b-[3px] md:py-1 py-1 border-[#FDBD26] text-center md:h-[74px] h-[20px] text-white"
          >
            {loading ? progressMsg || "Saving..." : "Register"}
          </button>
          {registrationError && <div style={{ color: "red" }}>{registrationError}</div>}
               <Modal
            isOpen={isModalOpen}
            onRequestClose={() => setIsModalOpen(false)}
            contentLabel="Registration Successful"
            className="modal-content"
            overlayClassName="modal-overlay"
          >
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
              aria-label="Close"
            >
              &times;
            </button>
            <div className="relative bg-white p-4 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[430px]">
              <div className="flex flex-col items-center justify-center text-center h-full w-full">
                <div className="relative mb-4 w-full flex justify-center items-center">
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                    alt="Success"
                    className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                  />
                  <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                    Registration successful
                  </div>
                </div>
                <p className="text-black text-[10px] md:text-[32px] mb-2">
                  Thank you for registering with Ad-Luck
                </p>
                <p className="text-black text-[10px] md:text-[32px] mb-4">
                  Your unique registration number is:
                </p>
                <div className="flex items-center justify-between w-full mb-6 mt-8 px-4">
                  <div className="flex-1 flex justify-center">
                    <span className="text-[12px] md:text-[32px] font-bold text-center md:ml-32 ml-5 tracking-wide">
                      {registrationNumber}
                    </span>
                  </div>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(registrationNumber);
                      setCopyMessage('Copied!');
                      setTimeout(() => setCopyMessage(''), 2000);
                    }}
                    className="bg-[#F38323] hover:bg-orange-600  text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]"
                  >
                    Copy
                  </button>
                </div>
                {copyMessage && (
                  <div className="text-black text-[14px] md:text-[18px] font-semibold">
                    {copyMessage}
                  </div>
                )}
                <a href='/'>
                  <button
                    onClick={() => setIsModalOpen(false)}
                    className="bg-[#03897B] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[500px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold"
                  >
                    Continue to Home
                  </button>
                </a>
              </div>
            </div>
          </Modal>
          <Project />
          {/* App Download Section */}
          <div className="md:h-4"></div>
          <h1 className="md:text-[36px] text-[10px] font-bold md:mt-8 mt-1 mb-4">Download App</h1>
          <div className="flex flex-wrap md:justify-between gap-8 md:gap-0 md:max-w-2xl items-center">
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_903_oqescj.png" className="h-[25px] md:h-[76px]" alt="App Store" />
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png" className="h-[25px] md:h-[76px]" alt="Google Play" />
          </div>
          <div className="md:h-4"></div>

        </div>
      </div>




    </div>
  );
};

export default RegisterOrganization;
// Custom styles for the modal



